import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=597a5276"
import script from "./SummaryTable.vue?vue&type=script&lang=js"
export * from "./SummaryTable.vue?vue&type=script&lang=js"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=597a5276&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports